import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connect } from 'react-redux'
import { pageView, sendEvent } from "../helpers/analytics";
import Airport from '../components/airport/airport'
class Home extends Component {

  componentDidMount () {
    pageView('/')
  }

  render () {
    const { isOpen } = this.props.menu
    return (
      <div className={`home ${isOpen ? 'blurred' : ''}`}>
        <ReactCSSTransitionGroup
          transitionName="bg"
          transitionAppearTimeout={1400}
          transitionAppear={true}
          transitionEnter={false}
          transitionLeave={false}>

          <div className="home_bg">
            <div className="container flex-center-vertical">
              <ReactCSSTransitionGroup
                transitionName="home_title"
                transitionAppearTimeout={1800}
                transitionAppear={true}
                transitionEnter={false}
                transitionLeave={false}>
                {/*<h1 className="h1">отпуск чтобы <br />улететь<span className="text-red">.</span></h1>*/}
                <h1  className="h1">
                  <Airport text="Уикенд" />
                  <Airport text="по-европейски" />
                </h1>

                <div className="home__lead">Как провести выходные? Конечно – в путешествии! Жители 23 европейских городов рассказали нам о секретных локациях для уикенда. Обещаем: даже хорошо знакомые города откроются вам с новой стороны</div>
              </ReactCSSTransitionGroup>

              <ReactCSSTransitionGroup
                transitionName="home_button"
                transitionAppearTimeout={2400}
                transitionAppear={true}
                transitionEnter={false}
                transitionLeave={false}>
                <span onClick={() => sendEvent('main', 'click', 'go')}><Link to="/place" className="button button--primary">Решись на путешествие</Link></span>
              </ReactCSSTransitionGroup>
            </div>
          </div>
        </ReactCSSTransitionGroup>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    menu: state.menu
  })
)(Home)


// WEBPACK FOOTER //
// ./src/routes/Home.js